import React from "react";
import { Link } from "react-router-dom";

export default function ProjectsItem({ id, title, image }) {
  return (
    <div className="projects__grid__item">
      <img className="projects__grid__item__img" src={image} alt={title} />
      <div className="projects__grid__item__overlay">
        <h4>{title}</h4>
        <Link
          className="projects__grid__item__overlay--btn"
          to={{
            pathname: `/projects/${id}/${title}`,
            state: id,
          }}
        >
          View Details
          <i className="ri-information-line" />
        </Link>
      </div>
    </div>
  );
}
